module.exports = __webpack_public_path__ + "static/media/4.186f1c7b.jpg";